export const APP_VERSION = '0.0.4';
export const STATE_KEY = '__APP_STATE__';
export const VERSION_KEY = '__APP_VERSION__';


// WEBPACK FOOTER //
// ./D:/Repos/university/my-composer/app/VERSION.js